import React from 'react';
import { Button } from 'antd';
import styles from './portals.module.css';

const URL = 'https://d3to9p4w6lww5g.cloudfront.net/assets/portal.glb';

export default function Portals({ loadAsset }) {
  function add() {
    loadAsset('portal', URL);
  }

  return (
    <div data-cy='portals-drawer'>
      <h1 className={styles.title}>Portals</h1>
      <Button
        onClick={add}
        type='primary'
        className={styles.button}
        data-cy='add-portal-button'
      >
        Add Portal
      </Button>
    </div>
  );
}
